/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-question.reducer';

export const SurveyQuestionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyQuestionEntity = useAppSelector(state => state.surveyQuestion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyQuestionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyQuestion.detail.title">SurveyQuestion</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.id}</dd>
          <dt>
            <span id="parentId">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.parentId">Parent Id</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.parentId}</dd>
          <dt>
            <span id="questionName">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.questionName">Question Name</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.questionName}</dd>
          <dt>
            <span id="questionSubtext">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.questionSubtext">Question Subtext</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.questionSubtext}</dd>
          <dt>
            <span id="questionRequired">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.questionRequired">Question Required</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.questionRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="answerRequired">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.answerRequired">Answer Required</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.answerRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="allowMutipleOptionSurveyAnswer">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.allowMutipleOptionSurveyAnswer">
                Allow Mutiple Option Survey Answer
              </Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.allowMutipleOptionSurveyAnswer ? 'true' : 'false'}</dd>
          <dt>
            <span id="dependentQuestionId">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.dependentQuestionId">Dependent Question Id</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.dependentQuestionId}</dd>
          <dt>
            <span id="dependentQuestionOptionId">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.dependentQuestionOptionId">Dependent Question Option Id</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.dependentQuestionOptionId}</dd>
          <dt>
            <span id="dependentAnswerId">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.dependentAnswerId">Dependent Answer Id</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.dependentAnswerId}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.sortOrder}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyQuestion.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyQuestionEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyQuestion.optionGroup">Option Group</Translate>
          </dt>
          <dd>{surveyQuestionEntity.optionGroup ? surveyQuestionEntity.optionGroup.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyQuestion.surveySection">Survey Section</Translate>
          </dt>
          <dd>{surveyQuestionEntity.surveySection ? surveyQuestionEntity.surveySection.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surveyQuestion.inputType">Input Type</Translate>
          </dt>
          <dd>{surveyQuestionEntity.inputType ? surveyQuestionEntity.inputType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/survey-question" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-question/${surveyQuestionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyQuestionDetail;
